'use client';

import { getSubDomain } from '@core/utils';
import { useSuspenseQuery } from '@tanstack/react-query';

import {
  AuthQueryOptions,
  BANNER_CONTENTS_TYPE,
  UnauthQueryOptions,
} from '@/api';
import { SUB_DOMAIN } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';

import { MainCarouselClient } from './MainCarouselClient';

export const MainCarousel = () => {
  const isLogin = useAuthStore((state) => state.isLogin);

  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const subdomain = getSubDomain(host);

  const entry =
    subdomain === SUB_DOMAIN.KB_PAY
      ? 'KB_PAY'
      : subdomain === SUB_DOMAIN.TOSS
        ? 'TOSS'
        : 'WELLO';

  const { data } = useSuspenseQuery(
    isLogin
      ? {
          ...AuthQueryOptions['get:/wello/v2/auth/banner']({
            query: {
              contentsTypeCd: BANNER_CONTENTS_TYPE.HOME_UPPER,
            },
          }),
        }
      : {
          ...UnauthQueryOptions['get:/wello/v2/allows/banner']({
            query: {
              contentsTypeCd: BANNER_CONTENTS_TYPE.HOME_UPPER,
              entry,
            },
          }),
        },
  );

  const items = data.context?.contents ?? [];

  if (items.length === 0) {
    return null;
  }

  return <MainCarouselClient items={items} />;
};
